<template>
  <div class="app-container">
    <tool-tip
      v-if="is_show_tool_tip"
      :text="text"
      @close-tool-tip="is_show_tool_tip = false"
    />
    <nav class="add-navigation">
      <div
        @click="$router.push({ name: 'system-admin-dids-all-dids' })"
        class="back-link mb-3"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to DIDs</p>
      </div>
      <div class="buttons-wrapper">
      </div>
    </nav>
    <div class="add-container">
      <loader :loading="loading" v-if="loading" />
      <not-found v-else-if="!imported_logs.length" />
      <template v-else>
        <div
          class="table_div"
          style="width: 100%; overflow-x: auto; overflow-y: hidden"
        >
          <table class="Invoice_table">
            <thead>
              <tr class="Invoice_table_header">
                <th class="file-name">File Name</th>
                <th class="date">
                  Created On
                  <span @click="sorting('asc', 'created_on')" class="sorting">&#8593;</span>
                  <span @click="sorting('desc', 'created_on')" class="sorting">&#8595;</span>
                </th>
                <th class="date">Finished On</th>
                <th class="status">Status</th>
                <th class="reply">Reply</th>
                <th class="created-by">Created By</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(log, index) in imported_logs"
                :key="`rnd-${index}`"
              >
                <th class="file-name">{{ log.file_name }}</th>
                <th class="date">{{ log.created_on }}</th>
                <th class="date">{{ log.finished_on }}</th>
                <th class="status">{{ log.status }}</th>
                <th
                  class="reply"
                  @mouseover="log.reply.length > showing_text_length ? toggleToolTip(log.reply, true) : null"
                  @mouseleave="log.reply.length > showing_text_length ? toggleToolTip(log.reply, false, $event) : null"
                >{{ log.reply | shortText(showing_text_length) }}</th>
                <th class="created-by">{{ log.created_by }}</th>
              </tr>
            </tbody>
          </table>
        </div>
        <div :style="{ display: paginationCondition ? 'flex' : 'block' }">
          <div class="per-page">
            <span class="filter_by">Show Per Page:</span>
            <div class="perPage">
              <primary-select
                type="text"
                @input="changePerPage"
                v-model="per_page" :is-cross="false"
              >
                <option
                  v-for="item in pages"
                  :key="item"
                  :value="item"
                >{{ item }}
                </option>
              </primary-select>
            </div>
          </div>
          <div
            class="buttons-wrapper"
            :class="{ pagination: paginationCondition }"
          >
            <pagination-component
              @change-page="changePage($event)"
              :page="Page"
              :total="totalPages"
              :perPage="per_page"
              :qnt="imported_logs.length"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
    ToolTip: () => import("@/components/ToolTip")
  },
  data() {
    return {
      showing_text_length: 40,
      is_show_tool_tip: false,
      text: "",
      imported_logs: [],
      loading: true,
      pages: [10, 50, 100],
      Page: 0,
      per_page: 10,
      totalPages: 0,
      order_by: 'created_on',
      order_dir: 'desc',
      tooltip_timeout: null
    }
  },
  computed: {
    paginationCondition() {
      return this.imported_logs.length < this.per_page && this.Page === 0;
    }
  },
  filters: {
    shortText(txt, length) {
      if (txt && txt.length > length) {
        return `${txt.substr(0, length).trim()}...`;
      }

      return txt;
    },
  },
  created() {
    this.GetList()
  },
  methods: {
    toggleToolTip(text, is_show, e) {
      clearTimeout(this.tooltip_timeout)

      if (!is_show) {
        const t = e && e.toElement.classList.contains("tool-tip");
        if (t) {
          return;
        }
        this.is_show_tool_tip = is_show;
        this.text = "";
        return;
      }

      this.tooltip_timeout = setTimeout(() => {
        this.is_show_tool_tip = is_show;
        this.text = text;
      }, 800)
    },
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    sorting(order_dir, order_by) {
      this.order_dir = order_dir
      this.order_by = order_by

      this.GetList()
    },
    GetList() {
      this.loading = true
      this.$store.dispatch('GetImportedLog', {
        page: this.Page || 0,
        per_page: this.per_page || 10,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc'
      })
      .then(res => {
        this.imported_logs = res.items.map(this.transformLogs)
        this.totalPages = res.total / this.per_page
        this.loading = false
      })
      .catch(err => {
        this.$snotify.error(err, { timeout: 6000 })
      })
    },
    transformLogs(item) {
      return {
        file_name: item.orig_file,
        created_on: format(item.created_on, 'YYYY:MM:DD HH:mm:ss'),
        finished_on: format(item.finished_on, 'YYYY:MM:DD HH:mm:ss'),
        status: item.status,
        reply: item.reply || '',
        created_by: item.created_by
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {

  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-top: 20px;
    margin-bottom: 20px;

    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;

      p {
        margin: 0;
      }
    }
  }
  .add-container {
    width: 100%;

    .table_div {
      width: 100%;

      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
          linear,
          left bottom,
          left top,
          color-stop(0.44, #51a3f3),
          color-stop(0.72, #51a3f3),
          color-stop(0.86, #51a3f3)
        );
      }
      .Invoice_table {
        min-width: 100%;
        border-collapse: collapse;

        tr {
          width: 100%;
          height: 40px;
          box-shadow: inset 0 -1px 0 0 #f0f1fa;
          -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
          -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
          background-color: #ffffff;

          th {
            padding: 0 10px;
            text-align: center;

            &.file-name {
              width: 300px;
            }
            &.date {
              width: 176px;
            }
            &.status {
              width: 180px;
            }
            &.reply {
              width: 340px;
            }
            &.created-by {
              width: 160px;
            }
          }
        }
        .Invoice_table_header {
          background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);

          th {
            border: 1px solid #f8f9fe;
            color: #fff;

            .sorting {
              cursor: pointer;
            }
          }
        }
        tbody th {
          font-family: "Helvetica Neue";
          font-size: 14px;
          font-weight: normal;
          color: #212b36;
        }
      }
    }
    .per-page {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .filter_by {
        margin-right: 15px;
        color: #55616e;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .perPage {
        width: 120px;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: 100%;

      &.pagination {
        width: fit-content;
        flex-grow: 1;
      }
    }
  }
}

@media screen and (max-width: 1550px) {
  .app-container {
    .add-container {
      .table_div {
        .Invoice_table {
          width: 1450px;
        }
      }
    }
  }
}
</style>